<template>
  <div class="paymentCenter w w1200">
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"><i></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="paymentCenter_right">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name='1' class="accountInformation" v-loading='loading'>
          <span slot="label"><i class="el-icon-user"></i> 账户信息</span>
          <div class="tab_pane_content">
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
              <el-form-item label="账号">
                <span class="nameBox">{{ userInfo.loginName }}</span>
                <span class="levelNum">{{ 'V' + level }}</span>
              </el-form-item>
              <el-form-item label="昵称" prop="nickname" :rules="{required: true, message: '请输入昵称', trigger: 'blur'}">
                <el-input v-model="ruleForm.nickname"></el-input>
              </el-form-item>
              <el-form-item label="头像" prop="avatar" :rules="{required: true, message: '请上传头像', trigger: 'blur'}">
                <el-upload
                  name="files"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <el-image class="avatar" :src="ruleForm.avatar" v-if="ruleForm.avatar">
                    <div slot="error" class="image-slot bg-font-size-big">
                      <i class="el-icon-user"></i>
                    </div>
                  </el-image>
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="ruleForm.gender">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生日" prop="date">
                <el-date-picker placeholder="选择日期" v-model="ruleForm.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="签名" prop="sign">
                <el-input type="textarea" v-model="ruleForm.sign"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="buttonBgd" @click="editHandle">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name='3'>
          <span slot="label"><i class="el-icon-key"></i> 账号安全</span>
          <div class="tab_pane_content tab_pane_content_num" v-if="!isApprovePage">
            <el-row>
              <el-col :span="2"><i class="el-icon-s-tools account_icon"></i></el-col>
              <el-col :span="16">
                <p class="accountNumber">实名认证
                  <i class="el-icon-warning notOperated"
                     v-if="userStatus.verified==null||userStatus.verified==1||userStatus.verified==''?true:false">未认证</i>
                  <i class="el-icon-warning notOperated"
                     v-if="userStatus.verified==2?true:false">{{ encryption(userStatus.identificationNum, 4) }}</i>
                  <i class="el-icon-warning notOperated" v-if="userStatus.verified==3?true:false"> 审核中</i>
                </p>
                <p class="account_desc OneLineDisplay">用于提升账号的安全性和信任级别。认证后的账号不能修改认证信息。</p>
              </el-col>
              <el-col :span="5">
                <el-button class="account_opreate"
                           v-if="userStatus.verified==null||userStatus.verified==1||userStatus.verified==''"
                           @click="approveHandle">认证
                </el-button>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="2"><i class="el-icon-lock account_icon"></i></el-col>
              <el-col :span="16">
                <p class="accountNumber">帐号密码</p>
                <p class="account_desc OneLineDisplay">用于保护帐号信息和登录安全</p>
              </el-col>
              <el-col :span="5">
                <el-button class="account_opreate" @click="numberEdit">修改</el-button>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="2"><i class="el-icon-message account_icon"></i></el-col>
              <el-col :span="16">
                <p class="accountNumber">安全邮箱
                  <i class="el-icon-warning notOperated"
                     v-if="userStatus.email==null||userStatus.email==''?true:false"> 未绑定</i>
                </p>
                <p class="account_desc notOperated OneLineDisplay"
                   v-if="userStatus.email!=null&&userStatus.email!=''?true:false">
                  {{ encryption(userStatus.email, 4) }}</p>
                <p class="account_desc notOperated OneLineDisplay"
                   v-if="userStatus.email==null||userStatus.email==''?true:false">安全邮箱将可用于登录帐号和重置密码，建议立即设置</p>
              </el-col>
              <el-col :span="5">
                <el-button class="account_opreate" @click="bindMailHandle">绑定</el-button>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="2"><i class="el-icon-mobile-phone account_icon"></i></el-col>
              <el-col :span="16">
                <p class="accountNumber">安全手机
                  <i class="el-icon-warning notOperated"
                     v-if="userStatus.photo==null||userStatus.photo==''?true:false"> 未绑定</i>
                </p>
                <p class="account_desc notOperated OneLineDisplay"
                   v-if="userStatus.photo!=null&&userStatus.photo!=''?true:false">
                  {{ encryption(userStatus.photo, 4) }} </p>
                <p class="account_desc notOperated OneLineDisplay"
                   v-if="userStatus.photo==null||userStatus.photo==''?true:false">安全手机将可用于登录帐号和重置密码，建议立即设置</p>
              </el-col>
              <el-col :span="5">
                <el-button class="account_opreate" @click="bindPhoneHandle">绑定</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="tab_pane_content tab_pane_content_num accountInformation" v-if="isApprovePage">
            <p class="approvePage">实名认证</p>
            <div class="tipsBg">
              提示：设置身份信息请务必准确填写本人的身份信息，注册后不能更改，隐私信息未经本人许可严格保密。
              <!-- 若你的身份信息和支付身份信息不一致，将会自动关闭已开通的提现服务 -->
            </div>
            <el-form :model="approveruleForm" status-icon :rules="rules" ref="approveruleForm" label-width="120px"
                     class="demo-ruleForm">
              <el-form-item label="真实姓名" prop="name">
                <el-input type="text" v-model="approveruleForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码" prop="IDNumber">
                <el-input type="text" v-model="approveruleForm.IDNumber" maxlength="18"
                          autocomplete="off"></el-input>
              </el-form-item>
              <!-- <el-form-item label="身份证照片" prop="IDImg">
                  <el-input type="password" v-model="approveruleForm.IDImg" autocomplete="off"></el-input>
              </el-form-item> -->
              <el-form-item label="身份证正面照" prop="IDImg">
                <el-upload
                  name="files"
                  class="avatar-uploader"
                  :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="handleAvatarIDSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="approveruleForm.IDImg" :src="IDCardImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="buttonBgd" @click="approvesubmitForm()">提交</el-button>
                <el-button @click="approveresetForm()">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 修改账号密码 开始 -->
    <el-dialog
      :visible.sync="editNumberdialog"
      :destroy-on-close=true
      :close-on-click-modal=false
      :before-close='resetForm'
      width="40%"
      title="账号密码"
      center>
      <el-form :model="numberruleForm" status-icon :rules="rules" ref="numberruleForm" label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="原密码" prop="oldpass">
          <el-input type="password" v-model="numberruleForm.oldpass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input type="password" v-model="numberruleForm.newPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="numberruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码" class="codeImgText" prop="code">
          <el-input type="text" placeholder="验证码" v-model="numberruleForm.code">
            <template slot="append">
              <div @click="refreshCode" class="codeImg">
                <s-identify :identifyCode="identifyCode" v-if="editNumberdialog"></s-identify>
              </div>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取消</el-button>
        <el-button type="primary" class="buttonBgd" @click="submitForm">提交</el-button>
      </div>
    </el-dialog>
    <!-- 修改账号密码 结束 -->

    <!-- 绑定安全邮箱 开始 -->
    <el-dialog
      :visible.sync="bindMailboxdialog"
      :destroy-on-close=true
      :close-on-click-modal=false
      :before-close='resetbindMailForm'
      width="40%"
      title="绑定安全邮箱"
      center>
      <el-form :model="bindMailruleForm" status-icon :rules="rules" ref="bindMailruleForm" label-width="100px"
               class="demo-ruleForm">
        <el-form-item class="phoneActiveStep">
          <el-steps :active="active" finish-status="success">
            <el-step title="请输入新邮箱"></el-step>
            <el-step title="验证新邮箱"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </el-form-item>
        <div v-if="active==0">
          <el-form-item label="新邮箱地址" prop="mailAddress">
            <el-input v-model="bindMailruleForm.mailAddress" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="codeImgText" prop="code">
            <el-input type="text" placeholder="验证码" v-model="bindMailruleForm.code">
              <template slot="append">
                <div @click="refreshCode" class="codeImg">
                  <s-identify :identifyCode="identifyCode" v-if="bindMailboxdialog"></s-identify>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="buttonBgd" @click="bindMailNext()">下一步</el-button>
          </el-form-item>
        </div>
        <div v-if="active==1">
          <el-form-item>
            <p>我们向 <em>{{ this.bindMailruleForm.mailAddress }}</em> 发送了验证邮件 <br/>请输入邮件中的验证码</p>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <el-input v-model="bindMailruleForm.verificationCode" autocomplete="off" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="buttonBgd" @click="submitbindMailForm()">提交</el-button>
            <!-- <el-button type="primary" class="buttonBgd" @click="bindMailNext()">下一步</el-button> -->
            <el-button @click="resetbindMailForm()">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 绑定安全邮箱 结束 -->

    <!-- 绑定手机 开始 -->
    <el-dialog
      :visible.sync="bindPhoneboxdialog"
      :destroy-on-close=true
      :close-on-click-modal=false
      :before-close='resetbindPhoneForm'
      width="40%"
      title="修改安全手机"
      center>
      <el-form :model="bindPhoneruleForm" status-icon :rules="rules" ref="bindPhoneruleForm" label-width="100px"
               class="demo-ruleForm">
        <el-form-item class="phoneActiveStep">
          <el-steps :active="phoneActive" finish-status="success">
            <el-step title="请输入新手机"></el-step>
            <el-step title="验证新手机"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </el-form-item>
        <div v-if="phoneActive==0">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="bindPhoneruleForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="codeImgText" prop="code">
            <el-input type="text" placeholder="验证码" v-model="bindPhoneruleForm.code">
              <template slot="append">
                <div @click="refreshCode" class="codeImg">
                  <s-identify :identifyCode="identifyCode" v-if="bindPhoneboxdialog"></s-identify>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="buttonBgd" @click="bindPhoneNext()">下一步</el-button>
          </el-form-item>
        </div>
        <div v-if="phoneActive==1">
          <el-form-item>
            <p>点击"发送短信"向 <em>{{ this.bindPhoneruleForm.phone }}</em> 发送验证短信 <br/>请输入短信中的验证码</p>
          </el-form-item>
          <el-form-item prop="verificationPhoneCode">
            <!-- <el-input v-model="bindPhoneruleForm.verificationPhoneCode" autocomplete="off" placeholder="请输入验证码"></el-input> -->
            <el-input placeholder="请输入验证码" v-model="bindPhoneruleForm.verificationPhoneCode">
              <template slot="append"><span v-if="!isShowButton" @click="sendMessage" style="cursor:pointer">发送短信</span>
              </template>
              <template slot="append"><span v-if="isShowButton" style="cursor: not-allowed;">{{ count }}秒后重新获取</span>
              </template>
            </el-input>

          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="buttonBgd" @click="submitbindPhoneForm()">确定</el-button>
            <el-button @click="resetbindPhoneForm()">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 绑定手机 结束 -->
  </div>
</template>
<script>
import {
  userDetails,
  editUser,
  resetPwd,
  sendSms,
  bindingPhone,
  bindingEmail,
  sendEmail,
  vEmail,
  authentication,
  querySendDetails,
  queryUserStatus
} from '../../api/xunyou'
import SIdentify from '@/components/sidentify'

export default {
  data() {
    return {
      loading: false,
      activeName: '1',
      // 账户信息修改
      likeGoods: 0,
      likeShop: 0,
      level: 0,
      urlImg: '',
      ruleForm: {
        nickname: '',
        avatar: '',
        date: '',
        gender: '',
        sign: '',
      },
      // 用户绑定状态集合
      userStatus: {},
      // 实名认证
      isApprovePage: false,
      IDCardImg: '',
      approveruleForm: {
        name: '',
        IDNumber: '',
        IDImg: '',
      },
      // 账号密码修改
      editNumberdialog: false,
      identifyCodes: "1234567890", // 验证码的范围
      identifyCode: "",
      numberruleForm: {
        oldpass: '',
        newPass: '',
        checkPass: '',
        code: '',
      },
      // 绑定安全邮箱
      bindMailboxdialog: false,
      active: 0,
      emailKey: '',
      bindMailruleForm: {
        mailAddress: '',
        code: '',
        verificationCode: ''
      },
      // 绑定手机
      bindPhoneboxdialog: false,
      phoneActive: 0,
      bindPhoneruleForm: {
        phone: '',
        code: '',
        verificationPhoneCode: ''
      },
      isShowButton: false,
      bizId: '',
      sendTime: '',
      count: '',
      timer: null,
      sendCode: true,
      rules: {
        name: [{
          required: true, trigger: ["blur", "change"],
          validator: (rule, value, callback) => {
            if (value == '') {
              callback(new Error('不能为空'));
            } else if (!(/^[\u4e00-\u9fa5]+$/gi.test(value)) || value.length < 2) {
              callback(new Error('请输入真实姓名'));
            } else {
              callback();
            }
          }
        }],
        IDNumber: [{
          required: true,
          trigger: ["blur", "change"],
          validator: (rule, value, callback) => {
            //验证身份证号码
            var idcode = value
            var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            var check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
            var code = idcode + "";
            var last = idcode[17];//最后一位
            var seventeen = code.substring(0, 17);
            var arr = seventeen.split("");
            var len = arr.length;
            var num = 0;
            for (var i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            var resisue = num % 11;
            var last_no = check_code[resisue];
            // 正则思路
            // 第一位不可能是0
            // 第二位到第六位可以是0-9
            // 第七位到第十位是年份，所以七八位为19或者20
            // 十一位和十二位是月份，这两位是01-12之间的数值
            // 十三位和十四位是日期，是从01-31之间的数值
            // 十五，十六，十七都是数字0-9
            // 十八位可能是数字0-9，也可能是X
            var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
            var format = idcard_patter.test(idcode);
            var result = (last === last_no && format)
            if (value == '') {
              callback(new Error('不能为空'));
            } else if (!result) {
              callback(new Error('身份证号码不正确'));
            } else {
              callback();
            }
          }
        }],
        nickname: [{required: true, message: "不能为空", trigger: ["blur", "change"]},],
        avatar: [{required: true, message: "不能为空", trigger: ["blur", "change"]},],
        oldpass: [{required: true, message: "不能为空", trigger: ["blur", "change"]},],
        verificationCode: [{required: true, message: "不能为空", trigger: ["blur", "change"]},],
        verificationPhoneCode: [{required: true, message: "不能为空", trigger: ["blur", "change"]},],
        newPass: [{
          required: true,
          //  message: "不能为空",
          trigger: ["blur"],
          validator: (rule, value, callback) => {
            let reg = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
            let result = reg.test(value);
            if (value == '') {
              callback(new Error('不能为空'));
            } else if (!result) {
              callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
            } else if (value == this.numberruleForm.oldpass) {
              callback(new Error('新旧密码一一致'));
            } else {
              callback();
            }
          }
        }],
        checkPass: [{
          required: true,
          // message: "不能为空",
          trigger: ["blur"],
          validator: (rule, value, callback) => {
            console.log(rule, value, '密码长度6~16位，其中数字，字母和符号至少包含两种')
            let regs = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
            let results = regs.test(value);
            if (value == '') {
              callback(new Error('不能为空'));
            } else if (!results) {
              callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
            } else if (value != this.numberruleForm.newPass) {
              callback(new Error('两次密码不一致'));
            } else {
              callback();
            }
          }
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: ['blur'],
          validator: (rule, value, callback) => {
            if (value == '') {
              callback(new Error('请输入验证码'));
            } else if (this.identifyCode !== value) {
              callback(new Error('验证码不正确，请重输入'));
              this.numberruleForm.code = '';
              this.bindMailruleForm.code = '';
            } else {
              callback();
            }
          }
        }],
        mailAddress: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
        ],
      },
    };
  },
  // 注册组件
  components: {SIdentify},
  computed: {
    userInfo () {
      return this.$store.state.userInfo;
    }
  },
  created() {
    if (this.$route.fullPath.indexOf('tap') > 0) {
      this.activeName = this.$route.query.tap
    }
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    this.getUserDetails();
    this.getBindStatus();
  },
  methods: {
    // 查询账户信息
    getUserDetails() {
      const req = {
        userId: this.$store.getters.userId,
      }
      this.loading = true;
      userDetails(req).then((res) => {
        console.log('用户详情：', res);
        this.loading = false
        if (res.code === 0) {
          this.ruleForm.name = res.data.username;
          this.ruleForm.nickname = res.data.nickname;
          this.ruleForm.avatar = res.data.avatar;
          this.ruleForm.date = res.data.birthday;
          this.ruleForm.gender = Number(res.data.sex) === 2 ? 0 : Number(res.data.sex);
          this.ruleForm.sign = res.data.signature;
          let userdata = this.$store.state.userInfo;
          userdata.userName = res.data.nickname;
          userdata.avatar = res.data.avatar;
          this.$store.commit('login', userdata);
        }
      }).catch((err) => {
        this.loading = false
        this.$message.error("查询我的信息失败，请稍后再试！");
      });
    },

    //   账户信息 上传头像
    handleAvatarSuccess(res, file) {
      console.log(res)
      this.ruleForm.avatar = res.url;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 修改按钮
    editHandle() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitApply();
        }
      });
    },
    // 修改按钮确认
    submitApply() {
      const req = {
        muid: this.$store.getters.userId,
        username: this.userInfo.loginName,
        nickname: this.ruleForm.nickname,
        avatar: this.ruleForm.avatar,
        sex: this.ruleForm.gender,
        birthday: this.ruleForm.date,
        signature: this.ruleForm.sign,
      }
      editUser(req).then(res => {
        console.log('修改结果:', res);
        if (res.code === 0) {
          this.$message.success('已更新');
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('提交失败，请稍后再试！');
      })
    },
    /**账户信息 结束**/

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.isApprovePage = false
    },

    // 用户绑定状态集合
    getBindStatus() {
      queryUserStatus({
        uid: this.userInfo.userId,
      })
        .then(res => {
          if (res.code == 0) {
            this.userStatus = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('提交失败，请稍后再试！')
        })
    },
    //  个人信息加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 3);
        var newStrs = str.substring(str.length, str.length - 4);
        newStr = newStr + "****" + newStrs;
        return newStr;
      }
    },

    /**实名认证 开始**/
    approveHandle() {
      this.isApprovePage = true
    },
    // 身份照片上传
    handleAvatarIDSuccess(res, file) {
      console.log(res, URL.createObjectURL(file.raw))
      this.IDCardImg = URL.createObjectURL(file.raw) // 用来图片预览的
      this.approveruleForm.IDImg = res.url;
      // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    },
    // 提交
    approvesubmitForm() {
      this.$refs.approveruleForm.validate((valid) => {
        if (valid) {
          const req = {
            muid: this.userInfo.userId,
            realname: this.approveruleForm.name,
            identificationNum: this.approveruleForm.IDNumber,
            icon: this.approveruleForm.IDImg,
          }
          authentication(req)
            .then(res => {
              if (res.code == 0) {
                this.isApprovePage = false
                this.getBindStatus()
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })

        } else {
          return false;
        }
      });
    },
    approveresetForm() {
      this.isApprovePage = false
    },
    /**实名认证 结束**/


    /**账号密码 开始**/
    numberEdit() {
      this.editNumberdialog = true;
    },
    // 提交
    submitForm() {
      this.$refs.numberruleForm.validate((valid) => {
        if (valid) {
          if (this.userInfo.userId == '' || this.userInfo.userId == null) {
            this.$message({
              type: 'info',
              message: '请登录'
            })
            this.$router.push({path: '/login'})
          }
          const req = {
            uid: this.userInfo.userId,
            phonenumber: this.userInfo.loginName,
            oldPassword: this.numberruleForm.oldpass,
            newPassword: this.numberruleForm.newPass
          }
          resetPwd(req)
            .then(res => {
              if (res.code == 0) {
                this.editNumberdialog = false
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.$router.push({path: '/login'})
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
        } else {
          return false;
        }
      });
    },
    // 取消
    resetForm() {
      this.numberruleForm = {
        oldpass: '',
        newPass: '',
        checkPass: '',
        code: ''
      }
      this.editNumberdialog = false;
    },

    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    /**账号密码 结束**/

    /**绑定安全邮箱 开始**/
    // 安全邮箱绑定
    bindMailHandle() {
      this.bindMailboxdialog = true
    },
    // 下一步
    bindMailNext() {
      this.$refs.bindMailruleForm.validate((valid) => {
        if (valid) {
          // 邮箱验证码发送成功，才可以进行跳转
          // this.active=1
          sendEmail({
            email: this.bindMailruleForm.mailAddress,
          })
            .then(res => {
              if (res.code == 0) {
                this.active = 1
                this.emailKey = res.msg
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
          // alert('submit!');
        } else {
          return false;
        }
      });
    },
    // 提交
    submitbindMailForm() {
      this.$refs.bindMailruleForm.validate((valid) => {
        if (valid) {
          vEmail({ // 邮箱验证
            key: this.emailKey,
            code: this.bindMailruleForm.verificationCode,
          })
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '邮箱验证码发送成功'
                })
                bindingEmail({ // 邮箱绑定
                  uid: this.userInfo.userId,
                  email: this.bindMailruleForm.mailAddress,
                })
                  .then(res => {
                    if (res.code == 0) {
                      this.active = 2
                      this.bindMailboxdialog = false
                      this.getBindStatus()
                      this.$message({
                        type: 'success',
                        message: '邮箱绑定成功！'
                      })
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.msg
                      })
                    }
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })


        } else {
          return false;
        }
      });
    },
    // 取消
    resetbindMailForm() {
      this.active = 0
      this.bindMailboxdialog = false,
        this.bindMailruleForm = {
          mailAddress: '',
          code: '',
          verificationCode: ''
        }
    },
    /**绑定安全邮箱 结束**/

    /**修改安全手机号 开始**/
    // 修改安全手机号
    bindPhoneHandle() {
      this.bindPhoneboxdialog = true
    },
    // 下一步
    bindPhoneNext() {
      this.$refs.bindPhoneruleForm.validate((valid) => {
        if (valid) {
          this.phoneActive = 1
          // alert('submit!');
        } else {
          return false;
        }
      });
    },
    // 发送短信
    sendMessage() {
      sendSms({
        TemplateCode: 'BIND_PHONE',
        phoneNumbers: this.bindPhoneruleForm.phone
      }).then((res) => {
        if (res.data.Message != 'OK') {
          return;
        } else {
          this.$message({
            type: 'success',
            message: '发送成功!'
          });
          //发送成功
          const bizId = res.data.BizId;
          this.bizId = bizId;
          var nowDate = new Date();
          var year = nowDate.getFullYear();
          var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
          var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
            .getDate();

          this.sendTime = year + '' + month + '' + day;

          const TIME_COUNT = 60;
          if (!this.timer) {
            this.isShowButton = true
            this.count = TIME_COUNT;
            this.sendCode = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.sendCode = true;
                this.isShowButton = false
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
        .catch((err) => {
          this.loading = false;
          this.$message.error("发送短信验证码失败，请稍后再试！");
        });
    },
    // 提交
    submitbindPhoneForm() {
      this.$refs.bindPhoneruleForm.validate((valid) => {
        if (valid) {
          const req = {
            phones: this.bindPhoneruleForm.phone,
            sendTime: this.sendTime,
            bizId: this.bizId,
            vcode: this.bindPhoneruleForm.verificationPhoneCode
          }
          querySendDetails(req)
            .then((res) => {
              if (res.code == 0) {
                //
                bindingPhone({
                  uid: this.userInfo.userId,
                  phone: this.bindPhoneruleForm.phone,
                })
                  .then(res => {
                    if (res.code == 0) {
                      this.phoneActive = 2
                      this.bindPhoneboxdialog = false
                      this.getBindStatus()
                      this.$message({
                        type: 'success',
                        message: '手机绑定成功！'
                      })
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.msg
                      })
                    }
                  })
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("校验失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 取消
    resetbindPhoneForm() {
      this.phoneActive = 0
      this.bindPhoneboxdialog = false,
        this.bindPhoneruleForm = {
          phone: '',
          code: '',
          verificationCode: ''
        }
    },
    /**修改安全手机号 结束**/

    // 绑定微信
    bindWXHandle() {
      alert('微信绑定')
    }
  },
};
</script>

<style scoped lang="less">
.paymentCenter {
  margin-top: 0;
  box-sizing: border-box;

  .breakcrumbHeader {
    margin: 15px 0;
  }

  .paymentCenter_left, .paymentCenter_right {
    background: white;
    padding: 20px;
    box-sizing: border-box;
  }

  .paymentCenter_left {
    .xunyouImg {
      text-align: center;
      width: 100%;
      // border-bottom: 1px solid #ccc;
      .xunyouText {
        border-radius: 50%;
        width: 160px;
        height: 160px;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
      }

      .xunyouShops {
        display: inline-block;
        padding: 20px;
        box-sizing: border-box;

        p {
          margin: 0px !important;
          font-size: 28px;
          font-weight: 500;
        }
      }

      .xunyouShops:hover {
        color: #ff7e00;
        cursor: pointer;
      }

      .el-divider--vertical {
        height: 4em;
        vertical-align: text-bottom;
      }

      span.levelNum {
        background-color: #40bbea;
        color: white;
        padding: 1px 10px;
        font-weight: bold;
        border-radius: 20px;
        margin-left: 5px;
      }
    }

    .money .sets:hover {
      color: var(--main-theme-color);
    }
  }

  .paymentCenter_right {
    /deep/ thead.has-gutter {
      color: #333;
      text-align: center;
    }

    .pagination {
      text-align: end;
      margin-top: 20px;

      /deep/ li.number {
        width: 40px;
      }

      /deep/ input[readonly], input[readonly="readonly"] {
        background-color: white;
      }
    }

    .moneyNum.el-row {
      .el-col {
        height: 100%;
      }

      height: 80px;
      background: red;

      .balance {
        height: 100%;
        background: #68b828;
      }

      .freezeBalance {
        height: 100%;
        background: #f7aa47;
      }
    }


    .accountInformation {
      span.nameBox {
        color: #8c8c8c;
      }

      span.levelNum {
        background-color: #40bbea;
        color: white;
        padding: 1px 10px;
        font-weight: bold;
        border-radius: 20px;
        margin-left: 5px;
      }

      /deep/ .avatar-uploader {
        padding-bottom: 15px;
        box-sizing: border-box;
      }

      /deep/ .el-upload.el-upload--text {
        border: 1px solid #ccc;
      }

      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }

      .avatar {
        width: 160px;
        height: 160px;
        display: block;
      }
    }

    .tab_pane_content_num {
      padding: 50px 30px;
      border: 1px solid #e2e2e2;
      border-radius: 10px;

      i.account_icon {
        font-size: 30px;
        height: 40px;
        line-height: 40px;
      }

      p.accountNumber {
        font-size: 16px;

      }

      p.account_desc {
        color: #9d9d9d;
        font-size: 14px;
      }

      .notOperated {
        color: #ff7e00 !important;
      }

      .el-button {
        width: 100%;
      }

      .el-button:focus, .el-button:hover {
        color: #ff7e00;
        // border-color: #c6e2ff;
        // background-color: #ecf5ff;
      }

      p.approvePage {
        font-size: 20px;
        color: #979898;
      }

      .tipsBg {
        background-color: #40bbea;
        border-color: #40bbea;
        color: #FFF;
        padding: 20px;
        margin: 10px 0;
        font-size: 14px;
      }
    }

    .bindingAuthorization {
      padding: 30px;

      p.bind_text {
        font-size: 18px;
        color: #979898;
      }

      .bind_desc {
        color: #979898;
        margin-bottom: 30px;
      }

      .bind_item {
        display: flex;
        justify-content: flex-start;

        .el-image {
          width: 15%;
          margin-right: 10px;
        }

        strong.num {
          font-size: 20px;
        }

        p.bind_itemHandle {
          width: 120px;
          background: #40bbea;
          text-align: center;
          color: white;
          border-radius: 10px;
          font-size: 14px;
          margin-top: 5px;
        }

        .bind_itemHandle:hover {
          cursor: pointer;
        }
      }
    }
  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: var(--main-theme-color);
    border-color: var(--main-theme-color);
    font-size: 16px;
    margin: 20px 0;
  }

  .phoneActiveStep {
    /deep/ .el-step.is-horizontal .el-step__line {
      top: 19px;
    }
  }
}


</style>







// WEBPACK FOOTER //
// src/views/siteNavigation/userCenter.vue